<template>
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        width="16"
        height="16"
    >
        <path d="M9 14 4 9l5-5"></path>
        <path d="M4 9h11a5 5 0 0 1 5 5v3"></path>
    </svg>
</template>
